import InteractiveMap from './interactive-map'

export default InteractiveMap
